interface ValueObjErrorCode {
  title: string;
  message: string;
  closeText: string;
}

export const ERORR_CODES: { [key: string]: ValueObjErrorCode } = {
  // EXAMPLE
  testing_message: {
    title: 'testing_message',
    message: 'cannotTestingMessage',
    closeText: 'close',
  },
};

export const IGNORE_ERROR_CODES: string[] = [
  // EXAMPLE
  'not_match_otp',
  'not_match_data_customer',
];
